// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rellpay-select {
  display: inline-block;
  position: relative;
  cursor: pointer;
  width: 100%;
}
.rellpay-select input {
  width: 100%;
  height: 100%;
  flex: 1;
  font-size: 12px;
  line-height: 1;
  font-weight: 800;
  cursor: pointer;
  font-family: Darker Grotesque;
}
.rellpay-select-content {
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 12px;
  transition: all 0.25s;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  transition: border-color 0.2s;
}
.rellpay-select-focus {
  border-color: var(--primary);
}
.rellpay-select-content svg {
  width: 14px;
  height: 14px;
  margin-left: 8px;
  transform: rotate(0);
  transition: all 0.2s;
}
.rellpay-select-show svg {
  transform: rotate(-180deg);
}
.rellpay-select-option {
  position: absolute;
  width: 100%;
  margin-top: -16px;
  border: 1px solid #0000000A;
  border-radius: 16px;
  padding: 14px 0 14px 2px;
  font-size: 12px;
  z-index: 10;
  background-color: #fff;
  width: calc(100% - 56px);
}
.rellpay-select-option-fadeIn {
  animation: fadeIn 150ms forwards;
}
.rellpay-select-option-fadeOut {
  animation: fadeOut 150ms forwards;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20%);
  }
  to {
    opacity: 1;
    transform: translateY(0%);
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateY(0%);
  }
  to {
    opacity: 0;
    transform: translateY(-20%);
  }
}
@keyframes mobileFadeIn {
  from {
    opacity: 0;
    transform: translateY(20%);
  }
  to {
    opacity: 1;
    transform: translateY(0%);
  }
}
@keyframes mobileFadeOut {
  from {
    opacity: 1;
    transform: translateY(0%);
  }
  to {
    opacity: 0;
    transform: translateY(20%);
  }
}
.rellpay-select-option-content {
  overflow-y: auto;
  max-height: 58vh;
  min-height: 38px;
}
.rellpay-select-option-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-inline: 18px;
  height: 48px;
  transition: all 0.1s;
  background-color: #fff;
  padding: 0 12px;
  transition: all 0.15s;
  cursor: pointer;
  font-size: 22px;
  font-weight: 500;
  line-height: 24px;
}
.rellpay-select-option-item img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.rellpay-select-option-item:hover,
.rellpay-select-option-item.active {
  background-color: #00000008;
}
.rellpay-select-option-btn {
  display: none;
}
.mask {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #00000033;
}
@media screen and (max-width: 851px) {
  .mask {
    display: block;
  }
  .rellpay-select-option-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 10px;
    font-size: 24px;
    font-weight: 700;
    line-height: 20px;
    margin-bottom: 30px;
  }
  .rellpay-select-option {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    margin-top: 0;
    text-align: center;
    border-radius: 24px 24px 0 0;
    padding: 19px 12px 46px;
  }
  .rellpay-select-option-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .rellpay-select-option-item {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    padding-block: 12px;
    justify-content: center;
    border: 1px solid #00000008;
  }
  .option-fadeIn {
    animation-name: mobileFadeIn;
  }
  .option-fadeOut {
    animation-name: mobileFadeOut;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Select/style.css"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AACJ;AAEA;EACI,WAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AAAJ;AAGA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;AADJ;AAIA;EACI,4BAAA;AAFJ;AAKA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;AAHJ;AAMA;EACI,0BAAA;AAJJ;AAOA;EACI,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,wBAAA;AALJ;AAQA;EACI,gCAAA;AANJ;AASA;EACI,iCAAA;AAPJ;AAUA;EACI;IACI,UAAA;IACA,2BAAA;EARN;EAWE;IACI,UAAA;IACA,yBAAA;EATN;AACF;AAYA;EACI;IACI,UAAA;IACA,yBAAA;EAVN;EAaE;IACI,UAAA;IACA,2BAAA;EAXN;AACF;AAcA;EACI;IACI,UAAA;IACA,0BAAA;EAZN;EAeE;IACI,UAAA;IACA,yBAAA;EAbN;AACF;AAgBA;EACI;IACI,UAAA;IACA,yBAAA;EAdN;EAiBE;IACI,UAAA;IACA,0BAAA;EAfN;AACF;AAkBA;EACI,gBAAA;EACA,gBAAA;EACA,gBAAA;AAhBJ;AAmBA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAjBJ;AAIA;EAgBQ,WAAA;EACA,YAAA;EACA,kBAAA;AAjBR;AAqBA;;EAEI,2BAAA;AAnBJ;AAsBA;EACI,aAAA;AApBJ;AAuBA;EACI,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;AArBJ;AAwBA;EACI;IACI,cAAA;EAtBN;EAyBE;IACI,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,kBAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;EAvBN;EA0BE;IACI,eAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,aAAA;IACA,aAAA;IACA,kBAAA;IACA,4BAAA;IACA,uBAAA;EAxBN;EA2BE;IACI,aAAA;IACA,sBAAA;IACA,SAAA;EAzBN;EA4BE;IACI,YAAA;IACA,iBAAA;IACA,mBAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;IACA,uBAAA;IACA,2BAAA;EA1BN;EA6BE;IACI,4BAAA;EA3BN;EA8BE;IACI,6BAAA;EA5BN;AACF","sourcesContent":[".rellpay-select {\n    display: inline-block;\n    position: relative;\n    cursor: pointer;\n    width: 100%\n}\n\n.rellpay-select input {\n    width: 100%;\n    height: 100%;\n    flex: 1;\n    font-size: 12px;\n    line-height: 1;\n    font-weight: 800;\n    cursor: pointer;\n    font-family: Darker Grotesque;\n}\n\n.rellpay-select-content {\n    display: flex;\n    align-items: center;\n    position: relative;\n    padding: 0 12px;\n    transition: all .25s;\n    border: 1px solid var(--border-color);\n    border-radius: 4px;\n    transition: border-color .2s;\n}\n\n.rellpay-select-focus {\n    border-color: var(--primary);\n}\n\n.rellpay-select-content svg {\n    width: 14px;\n    height: 14px;\n    margin-left: 8px;\n    transform: rotate(0);\n    transition: all .2s;\n}\n\n.rellpay-select-show svg {\n    transform: rotate(-180deg);\n}\n\n.rellpay-select-option {\n    position: absolute;\n    width: 100%;\n    margin-top: -16px;\n    border: 1px solid #0000000A;\n    border-radius: 16px;\n    padding: 14px 0 14px 2px;\n    font-size: 12px;\n    z-index: 10;\n    background-color: #fff;\n    width: calc(100% - 56px);\n}\n\n.rellpay-select-option-fadeIn {\n    animation: fadeIn 150ms forwards;\n}\n\n.rellpay-select-option-fadeOut {\n    animation: fadeOut 150ms forwards;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-20%);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0%);\n    }\n}\n\n@keyframes fadeOut {\n    from {\n        opacity: 1;\n        transform: translateY(0%);\n    }\n\n    to {\n        opacity: 0;\n        transform: translateY(-20%);\n    }\n}\n\n@keyframes mobileFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(20%);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0%);\n    }\n}\n\n@keyframes mobileFadeOut {\n    from {\n        opacity: 1;\n        transform: translateY(0%);\n    }\n\n    to {\n        opacity: 0;\n        transform: translateY(20%);\n    }\n}\n\n.rellpay-select-option-content {\n    overflow-y: auto;\n    max-height: 58vh;\n    min-height: 38px;\n}\n\n.rellpay-select-option-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding-inline: 18px;\n    height: 48px;\n    transition: all .1s;\n    background-color: #fff;\n    padding: 0 12px;\n    transition: all .15s;\n    cursor: pointer;\n    font-size: 22px;\n    font-weight: 500;\n    line-height: 24px;\n\n    img {\n        width: 24px;\n        height: 24px;\n        border-radius: 50%;\n    }\n}\n\n.rellpay-select-option-item:hover,\n.rellpay-select-option-item.active {\n    background-color: #00000008;\n}\n\n.rellpay-select-option-btn {\n    display: none;\n}\n\n.mask {\n    display: none;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: #00000033;\n}\n\n@media screen and (max-width: 851px) {\n    .mask {\n        display: block;\n    }\n\n    .rellpay-select-option-btn {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding-left: 10px;\n        font-size: 24px;\n        font-weight: 700;\n        line-height: 20px;\n        margin-bottom: 30px;\n    }\n    \n    .rellpay-select-option {\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        z-index: 1000;\n        margin-top: 0;\n        text-align: center;\n        border-radius: 24px 24px 0 0;\n        padding: 19px 12px 46px;\n    }\n\n    .rellpay-select-option-content {\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n    }\n\n    .rellpay-select-option-item {\n        height: 48px;\n        line-height: 48px;\n        border-radius: 12px;\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 24px;\n        padding-block: 12px;\n        justify-content: center;\n        border: 1px solid #00000008;\n    }\n\n    .option-fadeIn {\n        animation-name: mobileFadeIn\n    }\n\n    .option-fadeOut {\n        animation-name: mobileFadeOut\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
